export const coachVolunteerReportColorings = {
  hasVolunteeredAsACoachForThisDivAndHasSomeCoachCertAndHasSomeCoachAssignment: "#a2f9ff",
  hasVolunteeredAsACoachForThisDivAndHasSomeCoachCert: "#c3d7fa",
  hasVolunteeredAsACoachForThisDiv: "#cfe8ca",
  hasSomeCoachCertButHasNotVolunteeredAsACoachThisSeasonDiv: "#ecce9c",
} as const
